import { Typography, Paper, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { login } from '../../../actions/users'
import { bindSubmitActionToPromise } from '../../../utils/forms'
import LoginForm from './LoginForm'
import { Link as RouterLink } from 'react-router-dom'

const styles = ({ spacing, breakpoints }: any): any => ({
  container: {
    padding: spacing(),
    marginTop: '3rem',
    marginBottom: '4rem',
    [breakpoints.down('sm')]: {
      marginTop: spacing(1),
      marginBottom: spacing(2)
    }
  },
  item: {
    margin: spacing(),
    padding: spacing(2),
    textAlign: 'center'
  },
  signup: {
    margin: '15px 0'
  },
  paper: {
    padding: '2rem',
    borderRadius: '10px',
    maxWidth: 420,
    margin: '0 auto',
  },
  button: {
    marginTop: '15px',
    color: '#ffffff !important',
    backgroundColor: '#E2EBFD',
    borderColor: '#E2EBFD',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  newLandlordBox: {
    marginTop: spacing(2),
    padding: '2rem',
    borderRadius: '12px',
    backgroundColor: '#E2EBFD',
    boxShadow: '0 12px 30px rgba(148, 0, 74, 0.08)',
    maxWidth: 420,
    margin: '0 auto'
  },
  newLandlordEyebrow: {
    fontSize: '1.2rem',
    color: '#94004A',
    fontWeight: 700,
    marginBottom: spacing(1.5)
  },
  newLandlordDescription: {
    marginBottom: spacing(2),
    fontSize: '0.9rem'
  },
  newLandlordButton: {
    width: '100%',
    textTransform: 'uppercase',
    fontWeight: 600,
    backgroundColor: '#94004A',
    color: '#FFFFFF',
    borderRadius: '10px',
    padding: '12px 18px',
    boxShadow: '0px 3px 6px rgba(59, 0, 29, 0.2)',
    '& span': {
      font: '14px CircularRegular'
    },
    '&:hover': {
      backgroundColor: '#670033'
    }
  }
})

interface LoginProps extends WithTranslation {
  classes: any
  isAuthenticated: boolean
  loginUser: any
  autoLoggingIn?: boolean
}

const LoginWindow = ({
  classes,
  isAuthenticated,
  loginUser,
  autoLoggingIn,
  t
}: LoginProps) => (
  <div className={classes.container}>
    {isAuthenticated ? (
      <Typography className={classes.signup} variant='body2' gutterBottom>
        {t('login.alreadyLoggedIn')}
      </Typography>
    ) : (
      <>
        <Paper elevation={2} className={classes.paper}>
          <Typography variant='h3' style={{ fontSize: '2.5rem' }} gutterBottom>
            {t('login.title')}
          </Typography>
          <LoginForm loginUser={loginUser} classes={classes} autoLoggingIn={autoLoggingIn} />
        </Paper>
        <Paper elevation={0} className={classes.newLandlordBox}>
          <Typography variant='subtitle2' className={classes.newLandlordEyebrow}>
            {t('login.newLandlordEyebrow')}
          </Typography>
          <Typography variant='body1' className={classes.newLandlordDescription}>
            {t('login.newLandlordDescription')}
          </Typography>
          <Button
            component={RouterLink}
            to='/signup'
            className={classes.newLandlordButton}
            variant='contained'
            color='primary'
          >
            {t('login.newLandlordCTA')}
          </Button>
        </Paper>
      </>
    )}
  </div>
)

const mapStateToProps = () => ({
  isAuthenticated: false
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loginUser: bindSubmitActionToPromise(dispatch, login)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(LoginWindow)))
